import { faCircleExclamationCheck } from "@fortawesome/pro-regular-svg-icons/faCircleExclamationCheck";
import * as React from "react";
import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconShowSubtitle: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faCircleExclamationCheck} />;
};
